import { createContext, Dispatch, ReactNode, SetStateAction, useCallback, useMemo, useState } from "react";

export type TaskManagerContextValues = {
    closeTaskDetails: () => void;
    currentEmpresaId: number;
    currentTaskId: number;
    setCurrentTaskId: Dispatch<SetStateAction<number>>; 
    openDetails: boolean;
    setOpenDetails: Dispatch<SetStateAction<boolean>>;
}

export const TaskManagerContext = createContext<TaskManagerContextValues | undefined>(undefined);

export const TaskManagerProvider = ({ children, currentEmpresaId }: { children: ReactNode, currentEmpresaId: number }) => {
    const [openDetails, setOpenDetails] = useState(false);
    const [currentTaskId, setCurrentTaskId] = useState<number>(0);

    const value = useMemo<Omit<TaskManagerContextValues, "closeTaskDetails">>(() => {
        return {
            currentEmpresaId,
            currentTaskId,
            setCurrentTaskId,
            openDetails,
            setOpenDetails,
        };
    }, [openDetails, currentTaskId, currentEmpresaId]);

    const closeTaskDetails = useCallback(() => {
        setOpenDetails(false);
        setCurrentTaskId(0);
    }, []);

    return (
        <TaskManagerContext.Provider
            value={{
                ...value,
                closeTaskDetails
            }}>
            {children}
        </TaskManagerContext.Provider>
    );
}